import React, { Component } from 'react';
import { MysticalButton } from './ui/MysticalButton';
import { AudioPlayer } from './AudioPlayer';
import { Terminal, Shield, Cpu } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[85vh] sm:min-h-screen w-full flex items-center justify-center overflow-hidden pt-16 pb-8 sm:pt-20 sm:pb-10" data-id="element-70">
      {/* Background Elements */}
      <div className="absolute inset-0 fractal-grid opacity-30" data-id="element-71" />
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,rgba(0,212,255,0.05),transparent_70%)]" data-id="element-72" />

      <div className="container mx-auto px-4 relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-73">
        {/* Left Content */}
        <div className="space-y-5 sm:space-y-8 text-center lg:text-left" data-id="element-74">
          <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#00d4ff]/30 rounded bg-[#00d4ff]/5 text-[#00d4ff] text-xs font-mono tracking-widest animate-pulse-glow" data-id="element-75">
            <Terminal className="w-3 h-3" data-id="element-76" />
            CLASSIFIED INTELLIGENCE DOCUMENT
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight" data-id="element-77">
            <span className="block text-[#c8c0b0]" data-id="element-78">Stop Repeating</span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#c9a84c] to-[#f0d080] glow-text-gold" data-id="element-79">
              The Same Patterns
            </span>
          </h1>

          <p className="text-lg md:text-xl text-[#c8c0b0]/80 max-w-xl mx-auto lg:mx-0 leading-relaxed font-light" data-id="element-80">
            The world is a fractal simulation, and this is the manual to hack
            the code from within. The "Glitch" in your life isn't bad luck—it's
            an invisible pattern you're about to break.
          </p>

          <div className="flex flex-col gap-4 sm:gap-6 items-center lg:items-start" data-id="element-81">
            <MysticalButton onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-82">
              Access The Manual
            </MysticalButton>

            {/* Audio Player with Title */}
            <div className="w-full max-w-sm" data-id="element-83">
              <div className="font-mono text-xs mb-2 tracking-widest animate-pulse text-[#4BDE81]" data-id="element-84">
                [!] INTERCEPTING_AUDIO_SIGNAL... Extracting Base Code.
              </div>
              <AudioPlayer data-id="element-85" />
            </div>

            <MysticalButton variant="secondary" icon={false} onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-86">
              Read Sample Data
            </MysticalButton>
          </div>

          <div className="pt-4 sm:pt-8 flex items-center justify-center lg:justify-start gap-6 text-xs font-mono text-[#c8c0b0]/50" data-id="element-87">
            <div className="flex items-center gap-2" data-id="element-88">
              <Shield className="w-4 h-4" data-id="element-89" />
              SECURE CONNECTION
            </div>
            <div className="flex items-center gap-2" data-id="element-90">
              <Cpu className="w-4 h-4" data-id="element-91" />
              ENCRYPTED DATA
            </div>
          </div>
        </div>

        {/* Right Content - Book Cover */}
        <div className="relative flex justify-center lg:justify-end" data-id="element-92">
          <div className="relative w-[200px] sm:w-[300px] md:w-[400px] aspect-[9/16] animate-float" data-id="element-93">
            {/* Glow behind book */}
            <div className="absolute inset-0 bg-[#00d4ff]/20 blur-3xl rounded-full transform scale-110" data-id="element-94" />
            <div className="absolute inset-0 bg-[#c9a84c]/10 blur-3xl rounded-full transform scale-90 translate-y-10" data-id="element-95" />

            {/* Book Image */}
            <img src="https://cdn.magicpatterns.com/uploads/3iMLLFBpQ4i3Wa5vLuD1NS/HTPTG_9x16.png" alt="The True Game Book Cover" className="relative z-10 w-full h-full object-cover rounded shadow-[0_0_50px_rgba(0,0,0,0.5)] border border-[#c8c0b0]/10" data-id="element-96" />

            {/* Decorative tech elements */}
            <div className="absolute -top-10 -right-10 w-20 h-20 border-t-2 border-r-2 border-[#00d4ff]/30 rounded-tr-3xl" data-id="element-97" />
            <div className="absolute -bottom-10 -left-10 w-20 h-20 border-b-2 border-l-2 border-[#c9a84c]/30 rounded-bl-3xl" data-id="element-98" />
          </div>
        </div>
      </div>
    </section>;
}